export default __webpack_public_path__ + "static/media/dot-menu.632fa95f.svg";